// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mJDtmQCTGRviAh0mBIjy {
  height: calc(100vh - 230px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations/Item/Setting/General/index.module.less"],"names":[],"mappings":"AAEA;EACE,2BAAA;AADF","sourcesContent":["\n\n.container {\n  height: calc(100vh - 230px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `mJDtmQCTGRviAh0mBIjy`
};
export default ___CSS_LOADER_EXPORT___;
